import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const systemPreferenceDetailService = () => {
  return axiosInstance
    .get(ENDPOINTS.ADMIN.SYSTEM.PREFERENCE.READ)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
